export default __webpack_public_path__ + "static/media/threedots.a948f8bc.svg";